import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoutes";
import Admin from "./pages/Admin";
import Home from "./pages/Home";
import EditProduct from "./pages/EditProduct";
import DeleteProduct from "./pages/DeleteProduct";
import CreateProduct from "./pages/CreateProduct";
import Navbar from "./components/Navbar";
import Cart from "./pages/Cart";
import Shop from "./pages/Shop";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminNavbar from "./components/AdminNavbar";
import CreateUser from "./pages/CreateUser";
import Atletas from "./pages/Atletas";
import EditAtleta from "./pages/EditAtleta";
import DeleteAtleta from "./pages/DeleteAtleta";
import AcessarLoja from "./pages/AcessarLoja";
import RestrictedRoute from "./components/RestrictedRoutes";
import NavbarRestricted from "./components/NavbarRestricted";
import NovoPagamento from "./pages/NovoPagamento";
import AprovarCompras from "./pages/AprovarCompras";
import ListaCompras from "./pages/ListaCompras";
import Scout from "./pages/Scout/Scout";
import Atletes from "./pages/Scout/Athletes";
import Teams from "./pages/Scout/Teams";
import GameList from "./pages/Scout/GameList";
import GameForm from "./pages/Scout/GameForm";
import ScoutLocalNavbar from "./components/ScoutLocalNavbar";
import Games from "./pages/Scout/Games";
import PublicScout from "./pages/Scout/PublicScout";
import PublicNavbar from "./components/common/PublicNavbar";
import AcessarScout from "./pages/Scout/AcessarScout";
import ScouterProtectedRoute from "./components/ScouterProtectedRoute";
import AdminDiscounts from "./pages/AdminDiscounts";
import AdminPix from "./pages/AdminPix";
import AdminAccessLogs from "./pages/AdminAccessLogs";
import FloatingCartButton from "./components/FloatingCartButton";
import ImpersonationBanner from "./components/ImpersonationBanner";

//import ReactGA from "react-ga4";

//GA
//ReactGA.initialize(import.meta.env.VITE_REACT_APP_TRACKIN_ID);

function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isRestrictedRoute = location.pathname.startsWith("/ar");
  const isElectron = navigator.userAgent.toLowerCase().includes("electron");
  const isGamesRoute = location.pathname.startsWith("/games");
  // const [count, setCount] = useState(0);
  // Verifica se o usuário está autenticado (exemplo: usando um token ou contexto)
  const isAuthenticated = localStorage.getItem("token"); // Adapte conforme sua lógica de autenticação
  return (
    <>
      <ImpersonationBanner />
      {isAdminRoute ? (
        isElectron ? (
          <ScoutLocalNavbar />
        ) : (
          <AdminNavbar />
        )
      ) : isRestrictedRoute ? (
        <NavbarRestricted />
      ) : isGamesRoute ? (
        <PublicNavbar />
      ) : (
        <Navbar />
      )}

      <Routes>
        {/* Rota raiz: redireciona para /login ou /admin */}
        <Route
          path="/"
          element={
            isElectron ? (
              isAuthenticated ? (
                <Navigate to="/admin/games" replace />
              ) : isGamesRoute ? (
                <Navigate to="/scout" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            ) : (
              <Home />
            )
          }
        />

        <Route path="/login" element={<Login />} />
        <Route path="/acesso" element={<AcessarLoja />} />
        <Route path="/shop" element={<Navigate to="/ar/shop" replace />} />
        <Route path="/scout" element={<AcessarScout />} />

        <Route
          path="/ar/*"
          element={
            <RestrictedRoute>
              <SecureRoutes />
            </RestrictedRoute>
          }
        />

        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminRoutes />
            </ProtectedRoute>
          }
        />

        <Route
          path="/games/*"
          element={
            <ScouterProtectedRoute>
              <GamesRoutes />
            </ScouterProtectedRoute>
          }
        />

        {/* <Route
          path="/games/:id"
          element={
            <>
              <PublicNavbar />
              <PublicScout />
            </>
          }
        /> */}
      </Routes>

      {!isAdminRoute && <FloatingCartButton />}

      {isAdminRoute ? "" : <Footer />}
    </>
  );
}

const GamesRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Games />} />
      <Route path="scout/:id" element={<PublicScout />} />
    </Routes>
  );
};

const SecureRoutes = () => {
  return (
    <Routes>
      <Route path="/shop" element={<Shop />} />
      <Route path="/home" element={<Home />} />
      {/* <Route path="/home" element={<GameList />} /> */}
      <Route path="/cart" element={<Cart />} />
      <Route path="/pagamentos/novo" element={<NovoPagamento />} />
      <Route path="/compras" element={<ListaCompras />} />
    </Routes>
  );
};

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Admin />} />
      <Route path="/atletas" element={<Atletas />} />
      <Route path="/atletas/create" element={<CreateUser />} />
      <Route path="/atletas/edit/:id" element={<EditAtleta />} />
      <Route path="/atletas/delete/:id/:nome" element={<DeleteAtleta />} />
      <Route path="/compras/aprovar" element={<AprovarCompras />} />
      <Route path="/register" element={<Register />} />
      <Route path="/games/scout/:id" element={<Scout />} />
      <Route path="/athletes" element={<Atletes />} />
      <Route path="/teams" element={<Teams />} />
      <Route path="/games" element={<GameList />} />
      <Route path="/games/new" element={<GameForm />} />
      <Route path="/games/edit/:id" element={<GameForm />} />
      <Route path="/product/create" element={<CreateProduct />} />
      <Route path="/product/edit/:id" element={<EditProduct />} />
      <Route path="/product/delete/:id" element={<DeleteProduct />} />
      <Route path="/descontos" element={<AdminDiscounts />} />
      <Route path="/parametros/pix" element={<AdminPix />} />
      <Route path="/logs" element={<AdminAccessLogs />} />
    </Routes>
  );
};

export default App;
